import React from "react";
import ClearVerificationWeb from "./clearVerificationWeb";
import ClearVerificationMobile from "./clearVerificationMobile";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { connect } from "react-redux";
import { sendAnalytics } from "../../../action/homeAction"
import { IDCARD_DEMO } from "../../../config/constant";

const ClearVerification = (props) => {

    const [isWeb , setIsWeb] = React.useState(null)

    React.useEffect(() => {

        if(IDCARD_DEMO){
            props.skip();
        } else {
            if(window.device){
                setIsWeb(false)
            } else {
                setIsWeb(true)
            }
        }

        // Send Analytics
        const clear_id_verification_event_sent = localStorage.getItem("clear_id_verification_event_sent")
        let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })

        if (!clear_id_verification_event_sent) {
            props.sendAnalytics(
                null, // as no guesdetails in logout state 
                props.currentWidgetObj.widgetType || "Mobile Check-in",
                "CLEAR ID VERIFICATION",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken") },
                0,
                false, // guest is not logged in
                () => localStorage.setItem("clear_id_verification_event_sent", true)
            );
        }
    }, [])

    return (
        isWeb !== null ? isWeb ? <ClearVerificationWeb confirmationNumber={props.confirmationNumber} checkinDate={props.checkinDate} lastName={props.lastName} handleCLEARData={props.handleCLEARData} setNextScreen={props.setNextScreen} goBack={props.goBack} /> : <ClearVerificationMobile confirmationNumber={props.confirmationNumber} checkinDate={props.checkinDate} handleCLEARData={props.handleCLEARData} setNextScreen={props.setNextScreen} goBack={props.goBack} />: null
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
    }
  }
  
export default connect(mapStateToProps, {sendAnalytics})(ClearVerification);